import React from 'react';

import { useQueryClient } from '@tanstack/react-query';

export const useQueryResult = (key) => {
  const queryClient = useQueryClient();
  return queryClient.getQueryData(key);
};
